
import React from 'react';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';
import Navigation from '@/components/landing/Navigation';
import Footer from '@/components/landing/Footer';

interface BlogErrorStateProps {
  onLogin: () => void;
  onSignup: () => void;
}

export const BlogErrorState: React.FC<BlogErrorStateProps> = ({ onLogin, onSignup }) => {
  const navigate = useNavigate();
  
  return (
    <div className="bg-white min-h-screen">
      <Navigation onLogin={onLogin} onSignup={onSignup} />
      <div className="container mx-auto px-4 pt-32 pb-16 md:pt-40 md:pb-28 text-center">
        <h1 className="text-4xl font-bold mb-4">Post Not Found</h1>
        <p className="text-lg text-neutral-600 mb-8">The blog post you're looking for doesn't exist or has been removed.</p>
        <Button onClick={() => navigate('/blog')}>Back to Blog</Button>
      </div>
      <Footer />
    </div>
  );
};
